import { Box } from '@twilio-paste/core/box';
import { Menu, MenuButton, MenuItem, MenuSeparator, useMenuState } from '@twilio-paste/core/menu';
import { MoreIcon } from '@twilio-paste/icons/esm/MoreIcon';

import { TargetModel, TargetStatus } from '../../../../modules/Apps';
import { Action, Subject } from '../../../../modules/Permissions';
import { Can } from '../../../common/AbilityContext';

import { DeleteTargetDialog } from './DeleteTargetDialog';
import { DisableTargetDialog } from './DisableTargetDialog';
import { EnableTargetDialog } from './EnableTargetDialog';
import { useTargetsTableActions } from './lib';

interface TargetsTableActionsParams {
  target: TargetModel;
}

export function TargetsTableActions({ target }: TargetsTableActionsParams) {
  const menu = useMenuState();
  const {
    openEditTargetDrawer,
    handleCloseDisableDialog,
    handleOpenDisableDialog,
    isOpenDisableDialog,
    handleCloseEnableDialog,
    handleOpenEnableDialog,
    isOpenEnableDialog,
    openViewTargetDrawer,
    isOpenDeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
  } = useTargetsTableActions();

  return (
    <Box display="flex" justifyContent="center">
      <MenuButton {...menu} variant="reset" size="reset">
        <MoreIcon decorative={false} title="More options" />
      </MenuButton>
      <Menu {...menu} aria-label="Preferences">
        <Can I={Action.View} a={Subject.Target}>
          <MenuItem {...menu} onClick={openViewTargetDrawer(target)}>
            View
          </MenuItem>
        </Can>
        <Can I={Action.Edit} a={Subject.Target}>
          <MenuItem {...menu} onClick={openEditTargetDrawer(target)}>
            Edit
          </MenuItem>
          {target.status === TargetStatus.Enabled ? (
            <>
              <MenuItem {...menu} onClick={handleOpenDisableDialog}>
                Disable
              </MenuItem>
            </>
          ) : (
            <MenuItem {...menu} onClick={handleOpenEnableDialog}>
              Enable
            </MenuItem>
          )}
        </Can>
        <Can I={Action.Delete} a={Subject.Target}>
          <MenuSeparator />
          <MenuItem {...menu} variant="destructive" onClick={handleOpenDeleteDialog}>
            Delete
          </MenuItem>
        </Can>
      </Menu>
      <DisableTargetDialog
        handleClose={handleCloseDisableDialog}
        isOpen={isOpenDisableDialog}
        target={target}
      />
      <EnableTargetDialog
        handleClose={handleCloseEnableDialog}
        isOpen={isOpenEnableDialog}
        target={target}
      />
      <DeleteTargetDialog
        handleClose={handleCloseDeleteDialog}
        isOpen={isOpenDeleteDialog}
        target={target}
      />
    </Box>
  );
}
